module.exports = __webpack_public_path__ + "static/img/pic_home_zhanghao.cd30ff1.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/pic_home_zhanghao.png
// module id = 3GPT
// module chunks = 83